module.exports = __webpack_public_path__ + "static/img/1959_11_19_ViennaProgram_5.865e41e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_11_19_ViennaProgram_5.jpg
// module id = SJ+L
// module chunks = 0